<template>
  <router-view/>
</template>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
  --sidebar-width: 280px;
}

.main-content {
  margin-left: var(--sidebar-width) !important;
  transition: margin-left 0.3s ease;
}
</style>
